import { useEffect } from 'react';
import { authService } from '@/services/auth/authService';

/**
 * Reports real user interaction to authService, which gates the keep-alive refresh on it.
 *
 * This is not analytics: the server derives "last activity" from the rotating refresh
 * token, so without this gate the five-minute timer would report an untouched tab as
 * active forever and D7's idle bound could never fire. The listeners are passive and
 * only write a timestamp — the throttling that matters is already in authService, which
 * reads the value once per interval rather than reacting to every event.
 */
export const SessionActivityTracker = () => {
  useEffect(() => {
    const note = () => authService.noteUserActivity();
    // Deliberately NOT 'focus': macOS raises it for a space swipe past the window, a
    // Cmd-Tab pass-through or a wake from screen saver — none of which is a person at
    // the keyboard, and each would silently dismiss a running sign-out countdown.
    const events: (keyof WindowEventMap)[] = ['pointerdown', 'keydown', 'wheel', 'touchstart'];

    events.forEach((event) => window.addEventListener(event, note, { passive: true }));
    return () => events.forEach((event) => window.removeEventListener(event, note));
  }, []);

  return null;
};
